import React, { useEffect, useState } from 'react'
import SlbPopUp from '../controls/slbPopUp'
import { GetFormTemplateData, generalInfoField } from '../../common/controlHelper'
import { RenderForm } from '../jsonSchemaForm/formRenderer'
import { useForm } from 'react-hook-form'
import { TabView, TabPanel } from 'primereact/tabview';
import { VersionListing } from './VersionListing'
import { getDocVersionList } from '../../store/listing/listingSlice'
import { useDispatch } from 'react-redux'
import { getConfiguredLabel, jsonFromBase64 } from '../../common/commonHelper'
import { DocumentsPage, genInfoHeading, versionHistoryHeading } from '../../common/labelConstants'

const _props = {
  show: false,
  setShowPopup: () => { },
  fields: [],
  row: {},
  handleDownload: (selectedRows, setSelectedRows) => { },
}

export const VersionListingPopup = (props=_props) => {
  const editFields = generalInfoField(props.fields,props.row.metadata)
  const data = GetFormTemplateData(editFields, props.row)
  const rowId = props.row?._id
  const form = useForm({ defaultValues: {...data,id: rowId, actionType:'edit'} })
  const dispatch = useDispatch();
  const [versionData, setVersionData] = useState([])

  useEffect(()=>{
    const fetchData = async () => {
      dispatch(getDocVersionList({parentDocId:props.row.parentDocId})).then((res)=>{
        if(res?.payload?.data?.data!=[] && res?.payload.status === 200){
            let data = res?.payload?.data?.data
            if (typeof data === 'string') {
                data = jsonFromBase64(data)  
            }
            setVersionData(data)
        }
    })
  };
  fetchData()
  },[dispatch, props.row.parentDocId])

  return (
    <SlbPopUp
      show={props.show}
      title={props.row.fileName}
      headerClose={{
        show: true,
        onClick: (event) => {
          props.setShowPopup(false)
        }
      }}
      hideFooter={true}
    >
      <TabView className='rc_tabpanel'>
        <TabPanel header={getConfiguredLabel(DocumentsPage, genInfoHeading)}>
          {editFields && <RenderForm form={form} fields={editFields} />}
        </TabPanel>
        <TabPanel className='rc_version_history' header={getConfiguredLabel(DocumentsPage, versionHistoryHeading)}>
          <VersionListing parentId={props.row.parentDocId} rowsData={versionData} handleDownload={props.handleDownload}/>
        </TabPanel>
      </TabView>
    </SlbPopUp>
  )
}
